module.exports = __webpack_public_path__ + "media/evolve/assets/icons/fontawesome/solid/user-md-18da55fa458bc0c1069e51a4574d427b.svg";